import { Locale } from '@ps-smart-cp/ppfw-client';

const totalUnitNameConfig = {
  specifyInput: new Map([
    [Locale.ja, '入力指定'],
    [Locale.en, 'Specify Input'],
  ]),
  specifySelection: new Map([
    [Locale.ja, '選択指定'],
    [Locale.en, 'Specify Selection'],
  ]),
} satisfies Record<string, Map<Locale, string>>;

export { totalUnitNameConfig };
